module.exports = __webpack_public_path__ + "img/arrow-right.bbd61ad6.svg";